import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { LoginModule } from './login/login.module';
import { SubscriptionApplicationsModule } from './subscriptions/applications/subscription-applications.module';
import { SubscriptionReportingModule } from './subscriptions/reporting/subscription-reporting.module';
import { RedemptionApplicationsModule } from './redemptions/applications/redemptions-applications.module';
import { RedemptionReportingModule } from './redemptions/reporting/redemptions-reporting.module';
import { InvestorsModule } from './investors/investors.module';
import { DownloadsModule } from './downloads/downloads.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule.forRoot(),
        HttpModule,
        HttpClientModule,
        LoginModule,
        SubscriptionApplicationsModule,
        SubscriptionReportingModule,
        RedemptionApplicationsModule,
        RedemptionReportingModule,
        InvestorsModule,
        DownloadsModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
